export enum LeaveType {
    ANNUAL_LEAVE = 'Annual Leave',
    CASUAL_LEAVE = 'Casual Leave',
    LIEU_LEAVE = 'Lieu Leave',
    PATERNITY_LEAVE = 'Paternity Leave',
    SHORT_LEAVE = 'Short Leave',
    LEAVE_FOR_VOTING = 'Leave for voting',
    SPECIAL_LEAVE = 'Special Leave',
    STUDY_LEAVE = 'Study Leave',
    SICK_LEAVE = 'Sick Leave',
    MATERNITY_LEAVE = 'Maternity Leave',
    NO_PAY_LEAVE = 'No Pay Leave',
    WORK_FROM_HOME = 'Work From Home',
    CARRY_FORWARD_LEAVE = 'Carry Forward Leave'
};